import { useEffect, useRef, useState } from 'react'

interface HookReturn {
  refetchDataset: () => void
  refetchDatasetRefNum: number
  refetchDatasetNum: number
}

/**
 * Track state to allow the dataset to be refetched.
 * - Trigger refetch by toggling a state change.
 */
export const useRefetchFreshDataset = (): HookReturn => {
  const refetchDatasetRef = useRef<number>(0)
  const [refetchDatasetNum, setRefetchDatasetNum] = useState<number>(0)

  // Update the ref to use as a previous state value.
  useEffect(() => {
    refetchDatasetRef.current = refetchDatasetNum
  }, [refetchDatasetNum])

  function refetchDataset() {
    setRefetchDatasetNum(refetchDatasetNum ? 0 : 1)
  }

  return {
    refetchDataset,
    refetchDatasetRefNum: refetchDatasetRef.current,
    refetchDatasetNum,
  }
}
